export default __webpack_public_path__ + "img/skxnOyOI.9d0e2058.svg";